import {
  TerminFilterListApi,
  TezaurusTerminPair,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';

const client = new TerminFilterListApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const getTerminSearchResults = async (
  searchText: string,
  terminUuid: string,
  limit: number,
  options: { headers?: AxiosRequestHeaders } = {},
):
  Promise<ClientResponse<TezaurusTerminPair[]>> => {
  const {
    data,
    status,
  } = await client.getTerminyFilterByText(searchText, limit, options);
  const filteredData = data.filter(item => item.uuid !== terminUuid);
  return {
    data: filteredData,
    responseCode: status,
  };
};
